import React, { useEffect, useState } from 'react';
import {motion} from "framer-motion";
import s from "./FeesPersonalAccount.module.css"
import MyBtn from "../../../components/ui/MyBtn/MyBtn";
import {Link} from "react-router-dom";
import ellipse from '../../../assets/img/ellipse.svg'
import emptyEllipse from '../../../assets/img/eclipse-empty.svg'
import {Helmet} from "react-helmet-async";

const FeesPersonalAccount = () => {

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 500)

    useEffect(() => {

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 500);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);



    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
        >

            <Helmet>
                <title>Personal Account that provides Online Banking, IBAN & SEPA Money Transfers</title>
                <meta
                    name="description"
                    content="Open a digital bank account to access online banking, dedicated IBAN, SEPA & SEPA transfers,
                    digital payments, debit cards and fast currency exchange services."
                />
                <meta name="keywords" content=" personal IBAN account, SEPA money transfer, online bank account, SEPA
                Instant transfer, debit card"/>
            </Helmet>

            <div className={s.wrapper}>
                    <div className={s.small_elipse_container}>
                        <img src={ellipse} alt="" />
                    </div>

                    <div className={s.high_elipse_container}>
                        {isMobile ? <img src={emptyEllipse} alt="" /> : <img src={ellipse} alt="" />}

                        </div>
                <div className={s.container}>

                    <div className={s.desc_block}>
                        <div className={s.title_block}>
                            <h2 className={s.title}>
                                Opening a new account with us
                                <span className={s.title_color}>
                                has never been easier
                            </span>
                            </h2>

                        </div>
                        <div>
                            <p className={s.description}>
                                With just a few simple steps, you can easily open an account from the comfort of your
                                own home. Once your account is set up, you'll have the convenience of sending and
                                receiving money from your account within Europe or even outside of Europe. Say goodbye
                                to the hassle of traditional banking and embrace the ease and convenience of opening an
                                account with us today.
                            </p>
                        </div>
                        <div className={s.button_wrapper}>

                            <Link to={"/sign-up"}>
                                <MyBtn title={"Open Payment Account"}/>
                            </Link>
                        </div>

                        <div className={s.table_block}>
                            <div className={s.header}>

                                <span> Card fees and payment fees</span>
                                <span className={s.row_value}>Fee (EUR)</span>
                            </div>
                            <div className={s.body}>
                                <div className={s.row}>
                                    <span className={s.row_text}>Card Load Fee (%)</span>
                                    <span className={s.row_value}>1.50 <br/><span className={s.color_value}>(min 3.5 EUR)</span></span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Purchase Fee (in-store/online) International</span>
                                    <span className={s.row_value}>00.15 <span className={s.color_value}>+ 1.20 %</span></span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Purchase Fee (in-store/online) Domestic</span>
                                    <span className={s.row_value}>00.15 <span className={s.color_value}>+ 1.30 %</span></span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Cash Withdrawal Domestic</span>
                                    <span className={s.row_value}>01.50</span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Cash Withdrawal International</span>
                                    <span className={s.row_value}>01.50 <span className={s.color_value}>+ 1.50 %</span></span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Cash Withdrawal Decline</span>
                                    <span className={s.row_value}>00.50</span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>ATM Balance Inquiry</span>
                                    <span className={s.row_value}>00.00</span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Foreign Exchange (%)</span>
                                    <span className={s.row_value}>01.00</span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Card Issuing*</span>
                                    <span className={s.row_value}>10.00</span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Card Monthly fee</span>
                                    <span className={s.row_value}>02.50</span>
                                </div>
                            </div>
                            <span className={s.additional_price}>**Price for delivery by post. Delivery by courier possible for additional fee depending on the recipient’s country</span>
                        </div>

                        <div className={s.table_block}>
                            <div className={s.header}>
                                <span> Card transactions limits</span>
                                <span className={s.row_value}>EUR</span>
                            </div>
                            <div className={s.body}>
                                <div className={s.row}>
                                    <span className={s.row_text}>Card Max Balance</span>
                                    <span className={s.row_value}>20.000 </span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Top-up daily</span>
                                    <span className={s.row_value}>5.000</span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Top-up monthly</span>
                                    <span className={s.row_value}>40.000</span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Top-up annual </span>
                                    <span className={s.row_value}>200.000</span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Ecommerce - max value per transaction / per day</span>
                                    <span className={s.row_value}>5.000</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </motion.div>
    );
};

export default FeesPersonalAccount;
